import React from "react";
import { Button } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  root: ({ variantType, sizeType, colorType, disabled }) => {
    const colors = {
      primary: {
        main: "#0088CF",
        hover: "#0088CF66",
        text: "#F8F8F8",
        textBtn: "#90F2FA",
      },
      negative: {
        main: "#FF897D",
        hover: "#FF897D66",
        text: "#ffffff",
        textBtn: "#FF897D",
      },
    }[colorType];

    const common = {
      fontWeight: 700,
      borderRadius: "100px",
      fontSize: sizeType === "large" ? "14px" : "12px",
      lineHeight: "140%",
      letterSpacing: "1%",
      textAlign: "center",
      padding: "10px 24px",
      verticalAlign: "middle",
      transition: "all 0.2s",
      textTransform: "none",
    };

    const variants = {
      filled: {
        backgroundColor: disabled ? `${colors.main}66` : colors.main,
        color: disabled ? `${colors.text}66` : colors.text,
        "&:hover": { backgroundColor: colors.hover },
        "&:disabled": {
          backgroundColor: `${colors.main}33`,
          color: `${colors.text}33`,
          cursor: "not-allowed",
        },
      },
      outlined: {
        backgroundColor: "transparent",
        padding: "10px 24px",
        border: `2px solid ${colors.main}`,
        color: disabled ? `${colors.text}66` : colors.text,
        "&:hover": {
          backgroundColor: colors.hover,
          borderColor: colors.main,
        },
      },
      text: {
        backgroundColor: "transparent",
        color: disabled ? alpha(`${colors.textBtn}`, 0.66) : colors.textBtn,
        "&:hover": {
          backgroundColor: colors.hover,
        },
      },
    };

    return {
      ...common,
      ...variants[variantType],
    };
  },
});

export const ActionButton = ({
  variantType = "filled",
  colorType = "primary",
  sizeType = "large",
  icon,
  iconPosition = "start",
  children,
  disabled,
  ...rest
}) => {
  const classes = useStyles({ variantType, sizeType, colorType, disabled });

  return (
    <Button
      className={classes.root}
      disabled={disabled}
      startIcon={icon && iconPosition === "start" ? icon : undefined}
      endIcon={icon && iconPosition === "end" ? icon : undefined}
      {...rest}
    >
      {children}
    </Button>
  );
};
